import { formatToDecimalWithSeparator } from '../../utilities/textsFormatters';
import { formatYearDate } from '../../utilities/dates';

export const salesTaxTableFormatters = {
  reportDate: {
    label: 'Report Date',
    formatter: ({ startDate, maxDate }) => `${formatYearDate(startDate)} - ${formatYearDate(maxDate)}`
  },
  state: {
    label: 'State',
    formatter: ({ stateName }) => `${stateName}, US`
  },
  grossSales: {
    label: 'Gross Sales',
    formatter: ({ salesAmount }) => formatToDecimalWithSeparator(salesAmount)
  },
  salesTaxCollected: {
    label: 'Sales Tax Collected',
    formatter: ({ taxAmount }) => formatToDecimalWithSeparator(taxAmount)
  },
};
